import { useEffect, useState } from "react";

import { BREAKPOINT } from "@/configs/breakpoints";

// Convert a breakpoint to a media query string (eg. viewport width is <= breakpoint)
const getMediaQuery = (breakpoint: BREAKPOINT) => `(max-width: ${breakpoint})`;

/**
 * Hook returns if the viewport size matches a breakpoint
 */
export const useMediaQuery = (breakpoint: BREAKPOINT): boolean => useMatchesMediaQuery(getMediaQuery(breakpoint));

/** Whether the viewport matches a media query, for one a width breakpoint can't express. */
export const useMatchesMediaQuery = (query: string): boolean => {
    // Get initial state based on current viewport
    const [matches, setMatches] = useState<boolean>(() => window.matchMedia(query).matches);

    useEffect(() => {
        const media = window.matchMedia(query);

        // Set initial state (in case it changed between render and effect)
        setMatches(media.matches);

        const handleChange = () => setMatches(media.matches);
        media.addEventListener("change", handleChange);

        return () => media.removeEventListener("change", handleChange);
    }, [query]);

    return matches;
};
